export default __webpack_public_path__ + "static/media/logo-atf.a55a01ae.svg";